import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IPagingCarouselGallery, PagingCarouselGallery } from "./pagingCarouselGallery";

export interface IPagingCarouselGalleryWithZoomButton extends IPagingCarouselGallery {

}

export class PagingCarouselGalleryWithZoomButton extends PagingCarouselGallery implements IPagingCarouselGalleryWithZoomButton {

    private readonly _dispatchZoomButtonPressedCustomEvent;
    private readonly _displayZoomButton;

    constructor(public htmlElement: Element, topLevelHtmlElement?: HTMLElement) {
        super(htmlElement, UtilityEnums.ComponentOrientation.Horizontal, UtilityEnums.ComponentOrientation.Horizontal, topLevelHtmlElement);
        this._dispatchZoomButtonPressedCustomEvent = this.dispatchZoomButtonPressedCustomEvent.bind(this);
        this._displayZoomButton = this.displayZoomButton.bind(this);
        this.attachZoomPopOutOpenClickEventListener();
        this.attachZoomPopOutDisplayEventListener();
    }
    attachZoomPopOutOpenClickEventListener(): void {
        this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingCarouselGalleryWithZoomButton.ZoomButton)).addEventListener('click', this._dispatchZoomButtonPressedCustomEvent);
    }
    removeZoomPopOutOpenClickEventListener(): void {
        this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingCarouselGalleryWithZoomButton.ZoomButton)).addEventListener('click', this._dispatchZoomButtonPressedCustomEvent);
    }

    attachZoomPopOutDisplayEventListener(): void {
        window.addEventListener('load', this._displayZoomButton);
    }
    removeZoomPopOutDisplayEventListener(): void {
        window.addEventListener('load', this._displayZoomButton);
    }
    displayZoomButton(): void {
        console.log('PagingCarouselGalleryWithZoomButton: displayZoomButton');
        let zoomButton: Element = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingCarouselGalleryWithZoomButton.ZoomButton));
        zoomButton.classList.remove(StringEnums.CssClass.LbSelectableCarouselZoomHidden);
        this.removeZoomPopOutDisplayEventListener();
    }

    dispatchZoomButtonPressedCustomEvent() {
        this.htmlElement.dispatchEvent(this.zoomButtonPressedCustomEvent());
    }
    zoomButtonPressedCustomEvent() {
        console.log('PagingCarouselGalleryWithZoomButton: selectedCarouselCellSelectedEvent');
        return new CustomEvent(CustomEventEnums.ZoomButtonPressed, {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
            }
        });
    }
    dispose() {

        this.removeZoomPopOutOpenClickEventListener();
        super.dispose();
    }
}

